import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import CookieSettingWrapper from "./CookieSettingWrapper"; // Import Wrapper

ReactDOM.render(
  <>
    <App />
    <CookieSettingWrapper /> {/* Use the wrapper */}
  </>,
  document.getElementById('root')
);
